import { createApi } from '@reduxjs/toolkit/query/react'
import { IChatboxResponse, ITopics } from '../../interfaces/chats/IChatResponse'
import { deviceAxiosQuery } from '../../utils/axios/device.axios'

export const chatboxApi = createApi({
    reducerPath: 'chatbox',
    baseQuery: deviceAxiosQuery(),
    tagTypes: ['models', 'topics', 'chats'],
    endpoints: (builder) => ({
        chatbox: builder.mutation<{ data: IChatboxResponse }, any>({
            query: (payload) => ({
                url: `/chatbox/chat`,
                method: 'POST',
                data: payload
            })
        }),
        topicsList: builder.query<{ data: ITopics[] }, { type: 'HISTORY' | 'TOPIC' | null, userId: string }>({
            query: ({ type, userId }) => ({
                url: type ? `/chatbox/topics?type=${type}&userId=${userId}` : `/chatbox/topics?userId=${userId}`,
                method: 'GET'
            }),
            providesTags: ['topics']
        }),
        userConfigs: builder.query<any, void>({
            query: () => ({
                url: `/ai-search-engine/user-ai-search-config`,
                method: 'GET',
            }),
        }),
        configFirstRun: builder.query<any, void>({
            query: () => ({
                url: `/ai-search-engine/user-ai-search-config`,
                method: 'GET',
            }),
        }),
        uploadChatFile: builder.mutation<{ name: string, url: string }[], FormData>({
            query: (data) => ({
                url: `/hotel-world-user-invites/upload-chat-files`,
                method: 'POST',
                data
            }),
        }),
        getTopicChats: builder.mutation<{ data: IChatboxResponse[] }, { topic: string, userId: string }>({
            query: ({ topic, userId }) => ({
                url: `/chatbox/chat?topic=${topic}&userId=${userId}`,
                method: 'GET'
            })
        }),
        saveTopic: builder.mutation<{ data: IChatboxResponse[] }, string>({
            query: (topic) => ({
                url: `/chatbox/chat/${topic}/topic`,
                method: 'PUT'
            }),
            invalidatesTags: ['topics']
        }),
        reactMessage: builder.mutation<{ data: IChatboxResponse[] }, { action: 'like' | 'dislike' | 'favorite', messageId: string }>({
            query: ({ action, messageId }) => ({
                url: `/chatbox/messages/${messageId}/reaction`,
                method: 'PUT',
                data: { action }
            }),
        }),
    }),
})

export const {
    useChatboxMutation,
    useTopicsListQuery,
    useGetTopicChatsMutation,
    useSaveTopicMutation,
    useReactMessageMutation,
    useUploadChatFileMutation,
    useUserConfigsQuery,
    useConfigFirstRunQuery
} = chatboxApi